module.exports = __webpack_public_path__ + "media/img/avatars/profiles/standard-5e314be1bfe58eda32456e683744b335.jpg";